<template>
    <div class="row">
        <loader-c v-if="isSavingForm"></loader-c>

        <div class="col-12 fs-24 mb-2" id="contact-us-form">
            <strong>Escríbenos:</strong>
        </div>

        <div class="col-12 fs-18 mb-4">
            Si deseas conocer más sobre nuestra empresa, nuestros productos, servicios u obtener cualquier otro tipo de información, no dudes en contactarnos:
        </div>

        <div class="col-12">
            <ValidationObserver ref="validation" v-slot="{ invalid }">
                <form @submit.prevent="onSubmit">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <ValidationProvider name="Tu nombre" rules="required|max:150" v-slot="{ errors }">
                                    <label class="fs-14" for="contactName">Tu nombre <span class="color-secondary-n">*</span></label>
                                    <input type="text"
                                           class="form-control input-secondary-n"
                                           placeholder="Digita tu nombre"
                                           name="contactName"
                                           id="contactName"
                                           v-model="contactName">
                                    <span class="form-field-validation">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <ValidationProvider name="Correo electrónico" rules="required|email" v-slot="{ errors }">
                                    <label class="fs-14" for="contactEmail">Correo electrónico <span class="color-secondary-n">*</span></label>
                                    <input type="text"
                                           class="form-control input-secondary-n"
                                           placeholder="Digita tu correo electrónico"
                                           name="contactEmail"
                                           id="contactEmail"
                                           v-model="contactEmail">
                                    <span class="form-field-validation">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <ValidationProvider name="Teléfono celular" rules="required|max:20" v-slot="{ errors }">
                                    <label class="fs-14" for="contactPhone">Teléfono celular <span class="color-secondary-n">*</span></label>
                                    <input type="text"
                                           class="form-control input-secondary-n"
                                           placeholder="Digita tu teléfono celular"
                                           name="contactPhone"
                                           id="contactPhone"
                                           v-model="contactPhone">
                                    <span class="form-field-validation">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <ValidationProvider name="Mensaje" rules="required|min:10|max:200" v-slot="{ errors }">
                                    <label class="fs-14" for="contactPhone">Mensaje <span class="color-secondary-n">*</span></label>
                                    <textarea name="contactMessage"
                                              id="contactMessage"
                                              class="form-control input-secondary-n"
                                              rows="3"
                                              placeholder="Ingresa el mensaje de contacto"
                                              style="resize: none;"
                                              v-model="contactMessage">
                                    </textarea>
                                    <span class="form-field-validation">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <p-check color="success"
                                         class="p-icon p-curve p-bigger p-smooth"
                                         v-model="acceptTermsAndConditions">
                                    <i class="fe-check icon" slot="extra"></i>
                                </p-check>

                                <a class="a-white-s-underline fs-14" href="/terms-and-conditions" target="_blank">Acepto términos y condiciones</a> <span class="color-secondary-n">*</span>
                            </div>
                        </div>

                        <vue-recaptcha ref="recaptcha"
                                       @verify="onVerify"
                                       @error="onError"
                                       size="invisible"
                                       :sitekey="$page.props.googleRecaptchaKey">
                        </vue-recaptcha>

                        <div class="col-12 text-right">
                            <button type="submit" class="btn btn-secondary-n" :disabled="!acceptTermsAndConditions || invalid">Enviar</button>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import 'pretty-checkbox/src/pretty-checkbox.scss';

import PrettyCheck from 'pretty-checkbox-vue/check';

import VueRecaptcha from 'vue-recaptcha';

import LoaderC from '../General/LoaderComponent.vue';

import { checkCatch, showMessage } from '../../../utils';

export default {

    components: {

        'p-check': PrettyCheck,
        VueRecaptcha,
        LoaderC,

    },

    data() {

        return {

            contactName: '',
            contactEmail: '',
            contactPhone: '',
            contactMessage: '',
            acceptTermsAndConditions: true,

            isSavingForm: false,

        };

    },

    methods: {

        clearForm() {

            this.contactName = '';
            this.contactEmail = '';
            this.contactPhone = '';
            this.contactMessage = '';
            this.acceptTermsAndConditions = true;

            this.$nextTick(() => {

                this.$refs.validation.reset();

            });

        },

        onSubmit() {

            this.$refs.recaptcha.execute();

            this.isSavingForm = true;

        },

        onVerify(captcha) {

            if (captcha && this.acceptTermsAndConditions) {

                const parameters = {

                    g_recaptcha_response: captcha,
                    name: this.contactName,
                    email: this.contactEmail,
                    phone: this.contactPhone,
                    message: this.contactMessage,

                };

                axios
                    .post('/contact-us', parameters)
                    .then((response) => {

                        const { data } = response;

                        if (!data.success) {

                            showMessage('error', 'Atención', data.message);

                            this.isSavingForm = false;

                            return;

                        }

                        this.clearForm();

                        this.isSavingForm = false;

                        showMessage('success', 'Éxito', 'Tu información ha sido enviada con éxito.');

                    })
                    .catch((error) => {

                        checkCatch(error);

                    });

            }

        },

        onError() {

            this.isSavingForm = false;

        },

    },

};
</script>

<style>
.pretty input:checked ~ .state.p-success label:after,
.pretty.p-toggle .state.p-success label:after {
    background-color: var(--secondary-color) !important;
}
</style>
